import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import { useSetState } from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import StatusHandler from "Helpers/StatusHandler";
import {useSelector} from "react-redux";

function CoupleRightClick({ data,onChangeData }) {
  const { selectedUser } = useSelector((state) => ({
    selectedUser: state.project.selectedUser,
  }));
  const [controls, setControls] = useSetState({
    couple: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  useEffect(() => {
    (async () => {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProduct: data.Id_couple,
          All: true,
          UserSelect: 0,
          KeyRequestUser: selectedUser?.Key
        };
        const response = await DrawerService.getListProfileRight(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const projectList = response.data.Value;
          const items = projectList.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          const selectItem = items.find((item)=> item.Id === data.Id_couple)
          setControls({couple: {value: selectItem}});
          setControls({ couple: { selectItems: items } });
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    })();
  }, []);

  useEffect(()=>{
    onChangeData(controls);
  },[controls])

  return (
    <Grid item xs={12}>
      <MuiAutoComplete
          autoSelect= {true}
        options={controls.couple.selectItems}
        label={<Translator id={"couple"} />}
        value={controls.couple.value}
        id={"couple"}
        onChange={autoCompleteHandler}
      />
    </Grid>
  );
}

export default CoupleRightClick;
